import { WikiEditTabsAndNavResponse, WikiTabType } from './types';
import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { WikiNamespaces } from '../wikis';

type GetWikiEditTabsAndNavRequestOptions = CommonRequestOptions & {
   active: WikiTabType;
   namespace: WikiNamespaces;
   title: string;
};

export async function getWikiEditTabsAndNav({
   active,
   namespace,
   title,
   ...common
}: GetWikiEditTabsAndNavRequestOptions): Promise<WikiEditTabsAndNavResponse> {
   return makeRequest('get', `wikis/${namespace}/${title}/editTabsAndNav/${active}`, {
      ...common,
   });
}
